'use client'

import { Auth0Provider } from '@auth0/auth0-react'
import * as Tooltip from '@radix-ui/react-tooltip'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { useState } from 'react'
import Toasts from '@/components/ui/Toasts'
import DialogStateProvider from '@/provider/dialogState'
import LocalisationProvider from '@/provider/localisationProvider'

const Providers = ({ children }) => {
  // Get queryClient in other components:
  // import { useQueryClient } from '@tanstack/react-query'
  // const queryClient = useQueryClient()
  // const queryCache = queryClient.getQueryCache()
  // queryClient.invalidateQueries({ queryKey: ['accessToken', 'companies'] })
  const [queryClient] = useState(() => new QueryClient())

  return (
    <Auth0Provider
      domain={process.env.NEXT_PUBLIC_AUTH0_DOMAIN}
      clientId={process.env.NEXT_PUBLIC_AUTH0_CLIENT_ID}
      useRefreshTokens
      cacheLocation="localstorage" // needed to support page refresh w/ blocked 3rd party cookies
      useRefreshTokensFallback={false} // fallback for browsers, who support iframes (not Safari)
      authorizationParams={{
        redirect_uri: process.env.NEXT_PUBLIC_BASE_URL,
        audience: process.env.NEXT_PUBLIC_AUTH0_AUDIENCE,
        // scope: `offline_access, refresh_token`,
        // useRefreshTokens: true,
        // cacheLocation: 'localstorage',
      }}>
      <QueryClientProvider client={queryClient}>
        <LocalisationProvider>
          <DialogStateProvider>
            <Tooltip.Provider delayDuration={100}>
              {children}
              <Toasts />
            </Tooltip.Provider>
          </DialogStateProvider>
        </LocalisationProvider>
      </QueryClientProvider>
    </Auth0Provider>
  )
}

export default Providers
